import {
  AnalyticsAction,
  AnalyticsEventWithLabel,
  AnalyticsPageView,
  AnalyticsToggleTrackingAction,
} from "./types";

const siteImproveCache: Array<AnalyticsAction> = [];

const siteImproveScriptTagIsPresent = (): boolean =>
  document.getElementById("stag") !== null;

export function trackPageviewInSiteImprove(url: string, ref?: string): void {
  const urlPath = window.redactSiteImproveUrl(url);
  const fullUrl = window.location.origin + urlPath;

  let fullRefUrl: string | undefined;
  if (ref !== undefined) {
    const pageviewPath = window.redactSiteImproveUrl(ref);
    fullRefUrl = window.location.origin + pageviewPath;
  }

  const pageview: AnalyticsPageView = [
    "trackdynamic",
    {
      url: fullUrl,
      ref: fullRefUrl,
      title: document.title,
    },
  ];

  if (window._sz && siteImproveScriptTagIsPresent()) {
    window._sz.push(pageview);
  } else {
    siteImproveCache.push(pageview);
  }
}

export function siteImproveEvent({
  action,
  category,
  label,
}: AnalyticsEventWithLabel): void {
  const event: AnalyticsAction = ["event", category, action, label];
  if (window._sz && siteImproveScriptTagIsPresent()) {
    window._sz.push(event);
  } else {
    siteImproveCache.push(event);
  }
}

export const enableSiteImproveTracking = () => {
  const enableEvent: AnalyticsToggleTrackingAction = ["notrack", false];

  if (siteImproveScriptTagIsPresent()) {
    if (!window._sz) {
      siteImproveCache.push(enableEvent);
    } else {
      window._sz.push(enableEvent);
    }
    return;
  }

  const script = document.createElement("script");
  script.src = "https://siteimproveanalytics.com/js/siteanalyze_6015663.js";
  script.id = "stag";
  script.async = true;
  script.onload = () => {
    setTimeout(() => {
      siteImproveCache.forEach((action) => {
        if (window._sz) {
          window._sz.push(action);
        }
      });
    }, 500);
  };

  document.head.appendChild(script);
};
